function getIsDebug() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('debug');
}

export default getIsDebug;